info.helpMap = {
	'FILE' : 'help/'+info.lang+'/webui/syncpcwb-fileman-so.htm',
	'SHARE' : 'help/'+info.lang+'/webui/syncpcwb-sharing-so.htm',
	'_DEFAULT_': 'help/'+info.lang+'/webui/_manual.htm'
}
